module.exports = __webpack_public_path__ + "img/90501207en.2715c308.png";